import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { showOnboarding } from '@/util/helpers/onboarding-helpers';
import css from '../css/module/onboarding.css';
import DisplayHighlightFeature from './DisplayHighlightFeature';

export const BOTTOM = 'BOTTOM';
export const RIGHT = 'RIGHT';
export const LEFT = 'LEFT';
export const TOP = 'TOP';
export const BOTTOM_LEFT = 'BOTTOM_LEFT';
export const BOTTOM_RIGHT = 'BOTTOM_RIGHT';
export const SUMMARIZE = 'use-inline-AGGREGATE';
export const ACTION_DRILLDOWN = 'use-drilldown';
export const ACTION_DISABLE = 'use-disable-step';
export const ACTION_FILTER = 'use-filter';
export const DISMISS_ONBOARDING = 'dismiss-onboarding-on-'; // used to create action name when user dismissed onboarding element
export const CREATE_CHART = 'use-display-chart-';
export const ACTION_SAVE_QUERY = 'use-save-view';
export const ACTION_CLICK_ADD_SAVED_QUERY = 'click-add-saved-query';
export const ACTION_SAVE_DASHBOARD_CHANGES = 'click-save-dashboard-changes';
export const ACTION_CANCEL_DASHBOARD_CHANGES = 'click-cancel-dashboard-changes';
export const CREATE_TREND_CHART = 'use-display-chart-single_value';
export const ACTION_CLICK_TABLE_HEADER = 'click-table-header-dropdown';
export const ACTION_RESULTS_TABLE = 'results-table';
export const ACTION_ADD_METRIC = 'use-summarize-metric:added';
export const ACTION_ADD_DIMENSION = 'use-summarize-dimension:added';
export const ACTION_CHANGE_DIMENSION = 'use-summarize-dimension:changed';
export const ACTION_COMPLETE_SUMMARIZE = 'use-summarize:complete';
export const ACTION_STEPS = 'view-steps';

export const userIsFinishedOnboarding = (userActions) => {
  if (isPublicDatasets()) return true;
  if (userActions === null) return true;

  return (
    userActions[ACTION_COMPLETE_SUMMARIZE] ||
    userActions['signed-up-before-compulsory-onboarding'] ||
    userActions['datasource-has-at-least-one-saved-query']
  );
};

export const isPublicDatasets = () =>
  window.location.pathname.startsWith('/publicdatasets/');

class HighlightFeature extends Component {
  componentDidUpdate() {
    this.buildPopover();
  }

  componentDidMount() {
    this.buildPopover();
  }

  componentWillUnmount() {
    this.destroyPopover();
  }

  buildPopover = () => {
    if (this.showOnboarding()) {
      if (!this.popover) {
        this.popover = document.createElement('div');
        // the below styling is required, as otherwise if you scroll the 'body', the positioning of the popover will be off
        this.popover.style.position = 'fixed';
        this.popover.style.zIndex = 10;
        this.popover.style.top = 0;
        document.body.appendChild(this.popover);
      }
      this.renderPopover();
    } else {
      this.destroyPopover();
    }
  };

  destroyPopover = () => {
    if (this.popover) {
      // remove React component from DOM
      ReactDOM.unmountComponentAtNode(this.popover);
      // remove div from DOM
      document.body.removeChild(this.popover);
      this.popover = null;
    }
  };

  renderPopover = () => {
    const {
      text,
      targetAction,
      actions,
      position,
      title,
      style = {},
      requiredActions,
      maxWidth,
      hideButton,
      delay,
      modalIsOpen,
      hideWhenModalsOpen,
    } = this.props;

    // render the positioned dropdown inside the body div we created in componentDidMount
    ReactDOM.render(
      <DisplayHighlightFeature
        element={this._el}
        position={position}
        text={text}
        targetAction={targetAction}
        actions={actions}
        title={title}
        requiredActions={requiredActions}
        style={style}
        maxWidth={maxWidth}
        hideButton={hideButton}
        delay={delay}
        modalIsOpen={hideWhenModalsOpen ? modalIsOpen : null}
      />,
      this.popover,
    );
  };

  showOnboarding = () => {
    const { actions, targetAction, requiredActions } = this.props;
    return showOnboarding(actions, targetAction, requiredActions);
  };

  render() {
    const { position } = this.props;

    const containerStyle = {};

    if (!this.showOnboarding()) {
      return null;
    }

    if (
      position === BOTTOM ||
      position === BOTTOM_LEFT ||
      position === BOTTOM_RIGHT
    ) {
      containerStyle.top = '100%';
    }

    switch (position) {
      case RIGHT: {
        containerStyle.left = '100%';
        break;
      }
      case TOP: {
        containerStyle.bottom = '100%';
        break;
      }
      case LEFT: {
        containerStyle.right = '100%';
        break;
      }
    }

    return (
      <div
        className={`${css.container} position-absolute `}
        style={containerStyle}
        ref={(el) => (this._el = el)}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    actions: state.datasource.userActions,
    modalIsOpen: state.modals.meta.current || state.modals.meta.fullScreen,
  };
};

export default connect(mapStateToProps)(HighlightFeature);
